import { AsignacionResponse } from '../../models/Entities/Turnero';
import { CommonState } from '../common/state/commonState';

export interface TurneroAsignacionesState extends CommonState<AsignacionResponse> {
    isAssigning: boolean;
    successAssigning: boolean | undefined;
    failOnAssigning: boolean;

    isLiberating: boolean;
    successLiberating: boolean | undefined;
    failOnLiberating: boolean;

    isLoadingActivas: boolean;
    successLoadingActivas: boolean | undefined;
    failOnLoadingActivas: boolean;
}

export const TurneroAsignacionesUnloadState: any = {
    // loading all
    isLoadingAll: false,
    isLoadingAllSuccess: undefined,
    FailGettingAll: false,

    // updating all
    isUpdatingAll: false,
    isUpdatingAllSuccess: undefined,
    FailUpdatingAll: false,

    // loading one
    isLoadingOne: false,
    isLoadingOneSuccess: undefined,
    FailGettingOne: false,

    // updating
    isUpdatingOne: false,
    successUpdatingOne: undefined,
    failOnUpdatingOne: false,
    
    // adding
    isAddingNewOne: false,
    successAddingNewOne: undefined,
    failOnAddingNewOne: false,

    // deleting
    isDeletingOne: false,
    isDeletingOneSuccess: undefined,
    FailDeletingOne: false,

    // list and error
    list: [],
    error: undefined,

    // custom
    isAssigning: false,
    successAssigning: undefined,
    failOnAssigning: false,

    isLiberating: false,
    successLiberating: undefined,
    failOnLiberating: false,

    isLoadingActivas: false,
    successLoadingActivas: undefined,
    failOnLoadingActivas: false
};
